export default (listingAlias: string) => {
  try {
    if (!listingAlias) return false;

    const updatedListingAlias = listingAlias.split('_')[0];
    return updatedListingAlias
      ? /^(?=.*[a-zA-Z])[a-zA-Z0-9_-]+$|^\d+$/.test(updatedListingAlias) && updatedListingAlias.length <= 13
      : false;
  } catch {
    return false;
  }
};
